import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * TextField
 *
 * Styles:
 *
 * - [Proto](https://www.figma.com/file/gImnv1p0uOIizS33dnZJa9/Patient-App-2.0?type=design&node-id=572-23744&mode=design&t=IVx6Y8sYHkZ9vvQx-0)
 */
const MuiTextField = {};

/**
 * MuiInputLabel
 */
export const MuiInputLabel = {
  styleOverrides: {
    formControl: ({
      theme
    }) => _extends({}, theme.typography.subtitle2, {
      color: theme.palette.text.primary,
      height: 24,
      marginBottom: theme.spacing(0.5)
    })
  }
};

/**
 * MuiFormLabel
 */
export const MuiFormLabel = {
  styleOverrides: {
    root: ({
      theme
    }) => _extends({}, theme.typography.subtitle2, {
      color: theme.palette.text.primary
    })
  }
};

/**
 * MuiOutlinedInput
 */
export const MuiOutlinedInput = {
  styleOverrides: {
    root: ({
      ownerState,
      theme
    }) => ({
      borderRadius: 12,
      background: theme.palette.common.white,
      '&.Mui-readOnly': _extends({
        background: 'transparent'
      }, ownerState.startAdornment && {
        background: theme.palette.common.white
      }),
      // TODO danielmana move to the base theme options
      '& legend': {
        width: 0
      }
    })
  }
};
export default MuiTextField;